var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17646",
    "data-name": "Group 17646",
    transform: "translate(-630 -571)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_586",
    "data-name": "Ellipse 586",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(630 571)",
    fill: "#dfefec"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17581",
    "data-name": "Group 17581",
    transform: "translate(639.75 579.75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19542",
    "data-name": "Path 19542",
    d: "M7.428,20.929H3.767A2.517,2.517,0,0,1,1.25,18.412V3.767A2.517,2.517,0,0,1,3.767,1.25H14.751a2.517,2.517,0,0,1,2.517,2.517V8a.686.686,0,1,1-1.373,0V3.767a1.144,1.144,0,0,0-1.144-1.144H3.767A1.144,1.144,0,0,0,2.623,3.767V18.412a1.144,1.144,0,0,0,1.144,1.144H7.428a.686.686,0,0,1,0,1.373Zm3.661,0a.686.686,0,0,1-.485-.2.7.7,0,0,1-.2-.494V17.616a.65.65,0,0,1,.2-.476l8.357-9.281a2.581,2.581,0,0,1,3.561,0,2.526,2.526,0,0,1,0,3.561l-8.366,9.272a.65.65,0,0,1-.476.2H11.062Zm2.618-.686Zm-1.9-2.3v1.638h1.638l8.164-9.08a1.144,1.144,0,0,0,0-1.62,1.181,1.181,0,0,0-1.62,0Zm-3.46-1.593H5.6a.686.686,0,1,1,0-1.373H8.344a.686.686,0,0,1,0,1.373Zm4.576-4.576H5.6a.686.686,0,1,1,0-1.373H12.92a.686.686,0,1,1,0,1.373Zm0-4.576H5.6a.686.686,0,1,1,0-1.373H12.92a.686.686,0,1,1,0,1.373Z",
    transform: "translate(0 0)",
    fill: "#0c263d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFile);
export default __webpack_public_path__ + "static/media/upload_file.0ffa093509a17869cafd6399bd2aaf6c.svg";
export { ForwardRef as ReactComponent };